import React, { useState } from "react";
import { Row, Col, Popover, PopoverHeader, PopoverBody } from "reactstrap";

import "../../../assets/css/popover.css";

const TracePopupOverFecha = props => {
  const { data } = props;
  const [popoverOpen, setPopoverOpen] = useState(false);

  const toggle = () => setPopoverOpen(!popoverOpen);

  const idBtn = `datosFecha`;
  const clase = "mb-0 fa fa-info-circle ";

  if (data.length === 0) {
    return (<></>);
  }

  const trace = data.map((item, index) => {
    const id = `datosFechaId${index}`;
    return (
      <Row key={id}>
        <Col className="col-4">
          {item.nombre}
        </Col>
        <Col>
          {item.descripcion}
        </Col>
      </Row>
    );
  });

  const titulo = "Detalle Fecha";
  const header = (data.length > 0 ? <i id={idBtn} className={clase} style={{ cursor: "pointer" }}></i> : <i id={idBtn} className={clase}></i>);

  return (
    <span className="ml-1">
      {header}
      <Popover
        placement="left"
        isOpen={popoverOpen}
        target={idBtn}
        toggle={toggle}

      >
        <PopoverHeader>{titulo}</PopoverHeader>
        <PopoverBody>
          {trace}
        </PopoverBody>
      </Popover>
    </span>
  );
};



export default TracePopupOverFecha;